var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "video-modal-wrapper" } }, [
    _c(
      "div",
      {
        staticClass: "modal fade video-modal",
        attrs: { id: "video-modal", tabindex: "-1", role: "dialog" }
      },
      [
        _c("div", { staticClass: "modal-dialog" }, [
          _c("div", { staticClass: "modal-content" }, [
            _c("div", { staticClass: "modal-header" }, [
              _c("div", { staticClass: "modal-title h4" }, [_vm._v("Video")]),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "close",
                  attrs: { type: "button", "data-dismiss": "modal" },
                  on: { click: _vm.closeVideo }
                },
                [_vm._v("×")]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "modal-body" }, [
              _vm.showyoutube
                ? _c("div", { staticClass: "video-container" }, [
                    _c("iframe", {
                      attrs: {
                        width: "560",
                        height: "315",
                        src: "https://www.youtube-nocookie.com/embed/" + _vm.yt,
                        title: "Video",
                        frameborder: "0",
                        allow:
                          "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
                        allowfullscreen: ""
                      }
                    })
                  ])
                : _vm._e()
            ])
          ])
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }